import React from "react";
import CoffeePageSection from "../components/CoffeePageSection";

function CoffeePage({match, location}) {

  return (

    <CoffeePageSection
    bg="white"
    textColor="dark"
    size="md"
    bgImage=""
    bgImageOpacity={1}
    title="Caffè Primario"
    subtitle=""
    />

    );
  }

export default CoffeePage;


